// extracted by mini-css-extract-plugin
module.exports = {"priceSlider":"PriceSlider_priceSlider__Xgxb_","currPrice":"PriceSlider_currPrice__6ZaKm","btn":"PriceSlider_btn__oSucN"};